/**
 * Emoji reactions — the curated set (chat-thread experience PR-4, 2026-09-09).
 *
 * No emoji-picker dependency: a fixed, brand-neutral set that renders the same
 * on every platform. The QUICK row is what the picker shows first; the GRID is
 * the "more" panel. The union is the ALLOWLIST, mirrored VERBATIM in
 * firestore.rules (the reactions match) — `tests/groupThreads/reactionEmojiAllowlistParity.test.ts`
 * fails the build if the two ever differ, so a client can never persist an
 * emoji the rules refuse (and vice versa).
 */
export const REACTION_EMOJI_QUICK: readonly string[] = Object.freeze([
  '👍', '❤️', '😂', '🎉', '🙏', '👀', '✅', '🔥',
]);

export const REACTION_EMOJI_GRID: readonly string[] = Object.freeze([
  '👎', '😊', '😮', '😢', '😡', '🤔', '🤝', '👏',
  '💯', '⭐', '💡', '🚀', '🙌', '🤞', '💪', '🫶',
  '😅', '🥳', '😎', '🤯', '🫡', '👌', '✨', '⚡',
  '📌', '📝', '🗓️', '⏳', '❓', '❗', '🔁', '🚫',
]);

/** Every emoji a reaction may carry; order = quick row, then grid. */
export const REACTION_EMOJI_ALLOWLIST: readonly string[] = Object.freeze([
  ...REACTION_EMOJI_QUICK,
  ...REACTION_EMOJI_GRID,
]);

/** Per user, per message — the rules refuse a longer list. */
export const MAX_REACTIONS_PER_USER = 20;

const ALLOWED = new Set(REACTION_EMOJI_ALLOWLIST);

export function isAllowedReactionEmoji(value: unknown): value is string {
  return typeof value === 'string' && ALLOWED.has(value);
}
